import type { FieldDefinition, FieldType, MapDefinition } from '@grs-atlas/shared';

export const FIELD_TYPES: FieldType[] = [
  'text',
  'textarea',
  'number',
  'currency',
  'percentage',
  'date',
  'datetime',
  'boolean',
  'select',
  'multiselect',
  'tags',
  'email',
  'url',
  'states',
  'user',
  'confidence',
  'status',
];

export const DEFAULT_COLOR_RULE: NonNullable<MapDefinition['colorRule']> = {
  type: 'recordCount',
  field: null,
  buckets: [
    { min: 0, max: 0, label: 'No records', color: '#e8eef5' },
    { min: 1, max: 2, label: '1–2 records', color: '#9bb8d4' },
    { min: 3, max: 5, label: '3–5 records', color: '#4a7ba7' },
    { min: 6, max: null, label: '6+ records', color: '#1e3a5f' },
  ],
};

export function starterFields(): FieldDefinition[] {
  return [
    {
      key: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      searchable: true,
      tableVisible: true,
      detailVisible: true,
    },
    {
      key: 'stateCodes',
      label: 'States',
      type: 'states',
      required: true,
      filterable: true,
      tableVisible: true,
      detailVisible: true,
    },
    {
      key: 'notes',
      label: 'Notes',
      type: 'textarea',
      required: false,
      detailVisible: true,
    },
  ];
}

/** Convert a display name into a kebab-case mapId candidate. */
export function slugifyMapId(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 64);
}

export function fieldNeedsOptions(type: FieldType): boolean {
  return type === 'select' || type === 'multiselect' || type === 'status' || type === 'confidence';
}

export function blankField(type: FieldType = 'text'): FieldDefinition {
  return {
    key: '',
    label: '',
    type,
    required: false,
  };
}

export function deriveListFields(fields: FieldDefinition[]): {
  filters: string[];
  tableColumns: string[];
  tooltipFields: string[];
  detailFields: string[];
} {
  const keys = fields.map((f) => f.key).filter(Boolean);
  return {
    filters: fields.filter((f) => f.filterable && f.key).map((f) => f.key),
    tableColumns: fields.filter((f) => f.tableVisible && f.key).map((f) => f.key).length
      ? fields.filter((f) => f.tableVisible && f.key).map((f) => f.key)
      : keys.slice(0, 4),
    tooltipFields: keys.slice(0, 3),
    detailFields: keys,
  };
}
